import { useEffect, useState } from "react"
import { useIntl } from "react-intl"
import { useLocation, useHistory } from "react-router-dom"
import { useDispatch } from "react-redux"
import queryString from "query-string"
import { SHOW as ANSWERERRORPAGESHOW } from 'reducer/answerErrorPage'
import { validEmailShare } from 'ts-utils/survey'
import LangContainer from "./Lang"
import LineLoadingContainer from "./LineLoading"

const bad = ['dbz', 'kfo', 'xe']

type Lists = {
    [key: string]: {
        msg: string
        button: string
        url: string
        block: boolean
    }
}

const lists: Lists = {
    'uWyiXz4LT': { msg: '잠시후 다시 시도하시기 바랍니다.', button: '확인', url: 'https://www.listovey.com', block: false },


    // 테스트
    '8Vcbp10Yy': { msg: '설문 참여 인원이 마감되었습니다.', button: '확인', url: 'https://www.listovey.com', block: true }, 
    'k0rfVOINd': { msg: '설문 참여 인원이 마감되었습니다.', button: '확인', url: 'https://www.listovey.com', block: false },
    'Zhsjd': { msg: '설문 참여 인원이 마감되었습니다.', button: '확인', url: 'https://www.listovey.com', block: true }, 
    'xn9mE': { msg: '설문 참여 인원이 마감되었습니다.', button: '확인', url: 'https://www.listovey.com', block: false },

    

    


    '4myLG': { msg: '잠시후 다시 시도하시기 바랍니다.', button: '확인', url: 'https://www.listovey.com', block: false }, 
    '00hOl': { msg: '잠시후 다시 시도하시기 바랍니다.', button: '확인', url: 'https://www.listovey.com', block: false },
    'k7WBE': { msg: '잠시후 다시 시도하시기 바랍니다.', button: '확인', url: 'https://www.listovey.com', block: false }, 
    'Dtfj4': { msg: '잠시후 다시 시도하시기 바랍니다.', button: '확인', url: 'https://www.listovey.com', block: false },
    'qJfHt': { msg: '잠시후 다시 시도하시기 바랍니다.', button: '확인', url: 'https://www.listovey.com', block: false }
}

function GuardComponent(props: any) {
    const dispatch = useDispatch()
    const { formatMessage: f } = useIntl()

    const location = useLocation()
    const history = useHistory()

    const [ state, setState ] = useState(false)

    const search = queryString.parse(location.search)
    const pathname = location.pathname
    const args = pathname.split('/').pop()

    useEffect(() => {
        const isPossibleDoman = [
            process.env.REACT_APP_RESPOND_DOMAIN,
            process.env.REACT_APP_NEW_RESPOND_DOMAIN
        ]

        const hostname = window.location.hostname

        // 응답 도메인으로 들어온게 아니라면 홈페이지로 리다이렉션 시킨다
        if (!isPossibleDoman.includes(hostname)) {
            window.location.replace(process.env.REACT_APP_LANDING)
            return
        }

        if (search.email) {
            const { email } = search

            const valid = validEmailShare(String(email))

            /**
             * 이메일인지 핸드폰번호인지 판다
             */
            if (valid === 'email') {
                const dot = String(email).toLowerCase().split('.').pop()
                if (bad.includes(dot || '')) return
            } else if (valid === 'phone') {
                if (/-/.test(String(email))) {
                    history.push(`${pathname}?email=${String(email).replace(/-/g, '')}`)
                    return
                }
            }

            // 값이 없다면 이메일/휴대폰 형식이 아닌것
            if (!valid) return
        }

        if (args) {
            const list = lists[args]
            
            if (list) {
                if (list.block === true) {
                    dispatch({ 
                        type: ANSWERERRORPAGESHOW, 
                        message: list.msg,
                        logoHide: true,
                        buttonName: list.button,
                        buttonHref: list.url,
                        f,
                        iconType: 'private'
                    })
    
                    return
                }
              
            }

        }

        setState(true)
    }, [search, pathname, args, history, dispatch, f])

    if (!state) return null

    return (
        <>
        <LineLoadingContainer/>
        <LangContainer {...props}/>
        </>
    )
}

export default GuardComponent